<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">Quản lý khách hàng</div>
      </div>
      <div class="card card-w-title">
        <div class="box-top-list">
          <span class="p-m-0">Lịch sử thông tin khách hàng</span>
          <span class="right-button">
            <Button class="p-button-warning" :label="'Quay lại'" @click="backList" />
          </span>
        </div>
        <div class="list-data">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="full_name">Tên khách hàng <span class="error">*</span></label>
                <InputText type="text" disabled="true" v-model="full_name" />
              </div>
            </div>
            <!-- <div class="p-field p-col-12 p-md-6 bottom-title-address">
              <div class="p-col-8">
                <label >Địa chỉ</label>
               </div>
            </div> -->
            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="province_id">Tỉnh/Thành phố</label>
                <Dropdown :disabled="true"  placeholder="Chọn tỉnh/thành phố"  inputId="province_id" v-model="province_id" :options="provinces" optionLabel="label"  optionValue="value" />
              </div>
            </div>

            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="phone_number">Số điện thoại <span class="error">*</span></label>
                <InputText disabled="true" id="phone_number" type="text" v-model="phone_number" />
              </div>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="district_id">Quận/Huyện</label>
                <Dropdown  :disabled="true"  placeholder="Chọn quận/huyện"  inputId="district_id" v-model="district_id" :options="districts" optionLabel="label"  optionValue="value" />
              </div>
            </div>
            
            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="v">Ngày sinh</label>
                <Calendar :disabled="true" id="icon" v-model="birthday" :showIcon="true" placeholder="Nhập sinh" />
              </div>
            </div>

            
            
            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="ward_id">Phường/Xã</label>
                <Dropdown  :disabled="true"  placeholder="Chọn phường/xã" inputId="ward_id" v-model="ward_id" :options="wards" optionLabel="label"  optionValue="value" />
              </div>
            </div>

            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="email">Email</label>
                <InputText disabled="true" id="email" type="text" v-model="email" />
              </div>
            </div>

            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="address">Số nhà</label>
                <InputText disabled="true" id="address" type="text" v-model="address" />
              </div>
            </div>
            
            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="customer_type">Nhóm khách hàng <span class="error">*</span></label>
                <Dropdown :disabled="true" inputId="customer_type" v-model="customer_type" :options="customerType" optionLabel="label"  optionValue="value" />
              </div>
            </div>
            
             <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="status">Trạng thái hoạt động <span class="error">*</span></label>
                <Dropdown  :disabled="true" inputId="status" v-model="status" :options="optionStatus" optionLabel="label"  optionValue="value" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import moment from 'moment';
export default {
  data() {
    return {
      listData: [],
      modelName: 'customer_log_changed',
      provinces: [],
      districts: [],
      wards: [],
      full_name: '',
      phone_number: '',
      email: '',
      customer_type: 0,
      birthday: '',
      province_id: 0,
      district_id: 0,
      ward_id: 0,
      address: '',
      customerType: [{value: 1, label: 'Cá nhân'}, {value: 2, label: 'Doanhh nghiệp'}],
      optionStatus: [{value: 0, label: 'Ngưng hoạt động'}, {value: 1, label: 'Đang hoạt động'} ],
      status: 0
    }
  },
  async mounted () {
    this.dataModel = DataServices.getModel(this.modelName);
    if (this.$route.params.id !== undefined && !isNaN(this.$route.params.id)) {
      await this.getData(Number(this.$route.params.id));
    }
  },
  methods: {
    async getData(id) {
      var variables = {
        where_key: {
          id: {'_eq': id }
        }
      }
      var data = await DataServices.getList(this.modelName, {"variables": JSON.stringify(variables), "fields": "customer_profile_id new_value"});
      var list = data[Object.keys(data)];
      if(list && Object.keys(list).length) {
        this.listData = list[0];
        var newValue = this.listData.new_value;
        if (newValue && newValue != null) {
          newValue = JSON.parse(newValue);
          this.full_name = (newValue.full_name != undefined && newValue.full_name != null) ? newValue.full_name : '';
          this.phone_number = (newValue.phone_number != undefined && newValue.phone_number != null) ? newValue.phone_number.replace('+84', '0') : '';
          this.email = (newValue.email != undefined && newValue.email != null) ? newValue.email : '';
          this.address = (newValue.address != undefined && newValue.address != null) ? newValue.address : '';
          this.customer_type = (newValue.customer_type != undefined && newValue.customer_type != null) ? newValue.customer_type : 0;
          this.province_id = (newValue.province_id != undefined && newValue.province_id != null) ? newValue.province_id : 0;
          this.district_id = (newValue.district_id != undefined && newValue.district_id != null) ? newValue.district_id : 0;
          this.ward_id = (newValue.ward_id != undefined && newValue.ward_id != null) ? newValue.ward_id : 0;
          this.status = (newValue.status != undefined && newValue.status != null) ? newValue.status : 1;
          // console.log('sfdf', newValue.birthday);
          this.provincesData(this.province_id);
          this.districtsData(this.district_id);
          this.wardsData(this.ward_id);
          if (newValue.birthday != undefined && newValue.birthday != null && newValue.birthday != '') this.birthday = moment(newValue.birthday).format("DD/MM/YYYY");
        }
      }
    },
    async provincesData(id) {
      var variables = {
        where_key: {
          id: {'_in': [id] }
        }
      }
      var data = await DataServices.getList('provinces', {"variables": JSON.stringify(variables), "fields": "id,name"});
      var list = data[Object.keys(data)];
      if (list !== undefined && list !== null && Object.keys(list).length) {
        for (let index = 0; index < list.length; index++) {
          const item = list[index];
          this.provinces.push({label: item.name, value: item.id});
        }
      }
    },
    async districtsData(id) {
      var variables = {
        where_key: {
          id: {'_eq': id}
        }
      }
      var data = await DataServices.getList('districts', {"variables": JSON.stringify(variables), "fields": "id,name"});
      var list = data[Object.keys(data)];
      if (list !== undefined && list !== null && Object.keys(list).length) {
        for (let index = 0; index < list.length; index++) {
          const item = list[index];
          this.districts.push({label: item.name, value: item.id});
        }
      }
    },
    async wardsData(id) {
      var variables = {
        where_key: {
          id: {'_eq': id}
        }
      }
      var data = await DataServices.getList('wards', {"variables": JSON.stringify(variables), "fields": "id,name"});
      var list = data[Object.keys(data)];
      if (list !== undefined && list !== null && Object.keys(list).length) {
        for (let index = 0; index < list.length; index++) {
          const item = list[index];
          this.wards.push({label: item.name, value: item.id});
        }
      }
    },
    backList() {
      this.$router.push({path: '/admin/customer/history/' + this.listData.customer_profile_id});
    }
  }
}
</script>
<style lang="scss">
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.box-top-list{border: 1px solid #ccc; padding: 10px; 
  span{font-size: 25px; text-align: left; display: inline-block;}
  .right-button{float: right; 
    span{font-size: 14px;}
  }
}
.list-data{border: 1px solid #ccc; border-top: 0 none; padding: 20px;
  .bottom-title-address{display: flex; align-items: flex-end; font-weight: bold;}
}
</style>